module.exports = __webpack_public_path__ + "static/media/envelope-lock.d24ef935.svg";